import StripeV2 from '../libs/stripe.js'
import * as StripeV3 from '../libs/stripeV3.js'
import {determineCreditCardNeed} from '../ordoro/Modals/CreditCardModal.js'
import {getAPIKeys} from './apiKeys.js'
import {getReturnOrderCodes} from './returnOrderCodes.js'
import {getAllTasks} from './tasks.js'
import {migrateSticky} from '../redux/stickyFormMiddleware.js'
import {formSelector, updateForm, useAutoForm, useSelector} from '../store.js'
import {getAppMessages} from './appMessage.js'
import {getCarts} from './carts.js'
import {loadCompany} from './company.js'
import {getIntegrations} from './integrations.js'
import {getLayouts} from './layout.js'
import {loadMe} from './me.js'
import {getMOTags} from './moTags.js'
import {updateOrderCountsBase, updateOrderRevisionCount} from './orderCounts.js'
import {getOrderTags} from './orderTags.js'
import {getPackingLists} from './packingLists.js'
import {getPaymentAccounts} from './paymentAccounts.js'
import {getPOTags} from './poTags.js'
import {getPresets} from './presets.js'
import {getPrintConfigs} from './printConfigs.js'
import {setupPrinterSettingsForm} from './printerSettings.js'
import {getSomeProducts} from './products.js'
import {getProductTags} from './productTags.js'
import {getReports} from './reports.js'
import {getReturnOrderTags} from './returnOrderTags.js'
import {getShippers} from './shippers.js'
import {getStocktakeTags} from './stocktakeTags.js'
import {getSuppliers} from './suppliers.js'
import {getUsers} from './users.js'
import {getWarehouses} from './warehouses.js'
import {useEffect} from 'react'
import {getFilterConfigs} from './filterConfigs.js'
import {getContacts} from './contacts.js'

const DATA = 'data'
const INITIAL_FORM = {
  hasBegunLoadingData: false, // true after starting
  isDoneLoadingData: false, // true after successful data loaded
  loadingDataError: null, // has error if unsuccessfully loaded data
}

function dataFormSelector(state) {
  return formSelector(state, {formName: DATA}) || INITIAL_FORM
}

export function beginLoadingData() {
  updateForm(DATA, {hasBegunLoadingData: true})
}

function finishLoadingData() {
  updateForm(DATA, {isDoneLoadingData: true})
}

function onLoadingDataError(err) {
  updateForm(DATA, {loadingDataError: err})
}

export function hasBegunLoadingDataSelector(state) {
  return dataFormSelector(state).hasBegunLoadingData
}

export function isDoneLoadingDataSelector(state) {
  return dataFormSelector(state).isDoneLoadingData
}

export function loadingDataErrorSelector(state) {
  return dataFormSelector(state).loadingDataError
}

export async function initData() {
  try {
    loadCompany()
    loadMe()

    await Promise.all([
      getAPIKeys(),
      getAppMessages(),
      getContacts(),
      getFilterConfigs(),
      getIntegrations(),
      getLayouts(),
      getPackingLists(),
      getPOTags(),
      getPresets(),
      getProductTags(),
      getReturnOrderTags(),
      getReports(),
      getOrderTags(),
      updateOrderCountsBase(),
      updateOrderRevisionCount(),
      getCarts(),
      getShippers(),
      getWarehouses(),
      getSuppliers(),
      getMOTags(),
      StripeV2.init(),
      StripeV3.init(),
      getSomeProducts(),
      getUsers(),
      setupPrinterSettingsForm(),
      getPaymentAccounts(),
      getPrintConfigs(),
      getReturnOrderCodes(),
      getStocktakeTags(),
      migrateSticky(),
    ])

    finishLoadingData()
  } catch (err) {
    onLoadingDataError(err)
  }

  await determineCreditCardNeed()

  // task requests take too fucking long. switched to asynchronous version
  // switch back to getAllTasksBase() and put back in the Promise.all()
  // at the first opportunity
  getAllTasks()
}

export default function Data() {
  useAutoForm(DATA, INITIAL_FORM)

  const hasBegunLoadingData = useSelector(hasBegunLoadingDataSelector)

  useEffect(() => {
    if (hasBegunLoadingData) {
      initData()
    }
  }, [hasBegunLoadingData])

  return null
}
